import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components Global
import Modal from '../../../../../../../components/Modals/Modal'
import FormValidation from '../../../../../../../components/FormValidation'
import Select from '../../../../../../../components/input/Select/index'
import CheckBox from '../../../../../../../components/input/CheckBox/index'
import BtnSubmit from '../../../../../../../components/button/BtnSubmit'

// Util
import getFormValue from '../../../../../../../util/getFormValue'

// Actions
import { updateOrder } from '../../../../../../../redux/Orders/OrdersActions'



class VatEditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
  }

  fnStartModal() {
    let order = this.props.order
    let checkBox = order.vat.status === true

    this.mounted && this.setState({ checkBox: checkBox }, () => {
      this.setState({ disabled: this.checkDisabled() })
    })
  }

  checkDisabled = () => {
    let order = this.props.order
    let checkBox = this.state.checkBox
    let disabled

    if (order.vat.status) {
      if (checkBox === undefined) disabled = false
      else if (checkBox === true) disabled = false
      else if (checkBox === false) disabled = true
    } else {
      if (checkBox === undefined) disabled = true
      else if (checkBox === true) disabled = false
      else if (checkBox === false) disabled = true
    }

    return disabled
  }

  handleSubmit = (e, formName) => {
    e.preventDefault()
    let params = getFormValue(this.refs[formName])

    if (params['vat.rate'] === '0') {
      params['vat.status'] = false
    }

    const { business, order } = this.props
    const query = {
      authName: 'admin',
      dbNo: business.dbNo,
      businesses_id: business._id,
      orders_id: order._id
    }

    this.props.dispatch(updateOrder(query, {
      body: params,
      loadId: 'vatEditModal',
      modalId: 'vatEditModal',
      toastMsg: 'แก้ไขภาษีมูลค่าเพิ่มแล้ว'
    })).then(res => {
      if (res.success && this.props.fetch) {
        this.props.fetch()
      }
    })
  }

  onChange = (value, id) => {
    this.mounted && this.setState({ checkBox: value, disabled: value === false })
  }

  render() {
    let order = this.props.order

    return (
      <Modal
        id="vatEditModal"
        headerTitle="ภาษีมูลค่าเพิ่ม"
        headerLeft
        fnStartModal={() => this.fnStartModal()}
        width="350px"
        padding="0px">

        <div className="pd-15">
          <FormValidation ref="vatEditModal" name="vatEditModal" submit={(e) => this.handleSubmit(e, 'vatEditModal')} >
            <table>
              <tbody>
                <tr>
                  <td className="pd-0" width="40">
                    <CheckBox
                      id={`vat.status`}
                      size="sm"
                      value={order.vat.status}
                      onChange={this.onChange}
                      className="mg-top-15"
                    />
                  </td>
                  <td className="pd-0">
                    <Select
                      active
                      disabled={this.state.disabled}
                      disabledValue="true"
                      disabledPlaceholder="vat ใน"
                      id={`vat.include`}
                      default
                      value={order.vat.include}
                      className="mg-bottom-0"
                      options={[
                        { value: 'true', name: 'vat ใน' },
                        { value: 'false', name: 'vat นอก' },
                      ]}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="pd-top-15 text-right">
              <BtnSubmit
                icon="send"
                iconAlign="left"
                text="บันทึก"
                className="waves-effect waves-light btn light-green darken-1"
                loadingId="vatEditModal"
                btnDisabled
              />
            </div>
          </FormValidation>
        </div>
      </Modal>
    )
  }
}

export default connect()(VatEditModal)
